<template>
  <div :class="`chart most-popular md-layout-item md-size-${width} md-medium-size-${width} md-small-size-100`">
    <div class="most-popular-strategies">
      <h2>{{label}}</h2>
      <div>
        <apexchart type=bar height=340 :options="chartOptions" :series="series" />
      </div>
      <div class="spacer">&nbsp;</div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "MostPopularStrategies",
  computed: {},
  components: {
    apexchart: VueApexCharts
  },
  mounted() {},

  data() {
    let topActivities = window.drupalSettings.controller.graphs.MostPopularStrategies.data;
    let series = []
    series.push({
      name: 'Viewed',
      data: topActivities.map((activity) => {
        return activity.count_activities
      })
    })
    series.push({
      name: 'Badged',
      data: topActivities.map((activity) => {
        return activity.count_completed
      })
    })

    let categories = topActivities.map((activity) => {
      return activity.title
    })
    return {
      label: window.drupalSettings.controller.graphs.MostPopularStrategies.label,
      width: window.drupalSettings.controller.graphs.MostPopularStrategies.width || 33,
      series: series,
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          },
          offsetY: -20,
          offsetX: -5
        },
        colors: ['#457b9d', '#b0d7b9'],
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
            barHeight: '60%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
          style: {
            colors: ['#3c3c3c'],
            fontSize: '14px',
            fontFamily: 'Source Sans Pro'
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        legend: {
          fontSize: "14px",
          fontFamily: "Source Sans Pro",
          height: '20px',
          floating: true,
          offsetY: 5,
          labels: {
            colors: ['#3c3c3c'],
          },
        },
        xaxis: {
          categories: categories,
          labels: {
            style: {
              colors: ['#3c3c3c'],
              fontSize: '14px',
              fontFamily: "Source Sans Pro",
              cssClass: 'apexcharts-xaxis-label',
            },
            formatter: function(val) {
              return val.toFixed(0)
            }
          },
          axisBorder: {
            show: true,
            color: '#сссссс'
          },
          axisTicks: {
              show: true,
              color: '#3c3c3c'
          },
        },
        yaxis: {
          title: {
            text: '',
            style: {
              color: '#3c3c3c',
            },

          },
          labels: {
            style: {
              color: '#3c3c3c',
              fontSize: '14px',
              fontFamily: 'Source Sans Pro'
            }
          },
        },
        // fill: {
        //   type: 'gradient',
        //   gradient: {
        //     shade: 'dark',
        //     type: "vertical",
        //     shadeIntensity: 0.5,
        //     gradientToColors: ['#3D9AB9', '#FEA104'], // optional, if not defined - uses the shades of same color in series
        //     inverseColors: true,
        //     opacityFrom: 1,
        //     opacityTo: 1,
        //   }
        // },
        tooltip: {
          style: {
            fontSize: '14px',
            fontFamily: 'Source Sans Pro'
          },
          y: {
            formatter: function (val) {
              return val
            }
          }
        }
      }
    };
  },

  methods: {}
};
</script>
<style lang="scss">
  .most-popular-strategies {
   
    .apexcharts-svg {
      transform: translateZ(0);
    }
    .apexcharts-canvas {
      //transform: translate(-10px, -10px);
      .apexcharts-xaxis-label {
        font-family: "Source Sans Pro" !important;
        font-size: 14px !important;
      }
    }
    .apexcharts-legend {
      //transform: translate(20px, 0px);
    }
  }

</style>
